import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

import { Link } from "react-router-dom"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const Processing = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [permissions, setpermissions] = useState()
  const [processing, setprocessing] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("officer")
    plasticsUser.getProcessingApplications(userObj.id, 1).then(response => {
      if (response.status) {
        setprocessing(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setprocessing(response.data)
      })
    } else {
      plasticsUser.getProcessingApplications(userObj.id, page).then(response => {
        if (response.status) {
          setprocessing(response.data)
        }
      })
    }
  }

  const initiateSearch = data => {
    data = { ...data, application_status: "SUBMITTED,REVIEWED,UNDER REVIEW,DEPARTMENT APPROVED,SENT_BACK_HoD,SENT_BACK_DG,RETURN TO APPLICANT,PROPOSE TO APPROVE,PROPOSE TO REJECT,PROPOSE TO RETURN BACK,DEPARTMENT_REJECTED" }
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setprocessing({ data: [] })
        } else {
          setprocessing(response.data)
        }
      } else {
        setprocessing({ data: [] })
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Processing | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Processing</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All processing applications you will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              <ApplicationFilter
                allApplications={false}
                handleSearch={initiateSearch}
                turnOffSearch={turnOffSearchMode}
              />
              <Applications
                viewOnly={true}
                user={user}
                data={processing}
                paginate={paginate}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Processing
